import { render, staticRenderFns } from "./Testimonials.vue?vue&type=template&id=10ae4a00&scoped=true"
import script from "./Testimonials.vue?vue&type=script&lang=ts"
export * from "./Testimonials.vue?vue&type=script&lang=ts"
import style0 from "./Testimonials.vue?vue&type=style&index=0&id=10ae4a00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae4a00",
  null
  
)

export default component.exports